module.exports = __webpack_public_path__ + "static/media/psicologo.423446db.png";